import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CatalogueProvider } from "@/context/CatalogueContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Editor from "@/pages/Editor";
import Settings from "@/pages/Settings";
import SharePage from "@/pages/SharePage";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#090D16] grid place-items-center"><div className="scan-dot" /></div>;
  if (!user) return <Navigate to="/" replace />;
  return children;
};

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/project/:id" element={<Protected><Editor /></Protected>} />
      <Route path="/share/:token" element={<SharePage />} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CatalogueProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" />
        </CatalogueProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
